<template>
  <main>
    <slot />
  </main>
</template>

<script setup></script>

<style lang="scss" scoped></style>
